import { http, HttpResponse } from 'msw'
import { CaseStudy, CreateCaseStudyRequest } from '../models/case-studies.model'
import { CASE_STUDIES_ENDPOINTS } from '../constants'

let mockCaseStudies: CaseStudy[] = [
  {
    id: '1',
    title: 'Peace Process in Region X',
    author: 'John Doe',
    content: '<p>This is a detailed case study exploring the <strong>peace process</strong>...</p><img src="https://picsum.photos/800/400" alt="Sample" />',
    videos: [
      { title: 'Interview with Mediator', url: 'https://youtube.com/watch?v=123' }
    ],
    audios: [
      { title: 'Peace Agreement Signing', url: 'https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3' }
    ],
    status: 'PUBLISHED',
    updatedAt: new Date().toISOString(),
  }

];

export const caseStudiesHandlers = [
  http.get(CASE_STUDIES_ENDPOINTS.LIST, () => {
    return HttpResponse.json({
      status: true,
      status_code: 200,
      message: 'OK',
      data: {
        data: mockCaseStudies,
        total: mockCaseStudies.length
      },
      error: null
    });
  }),


  http.get(CASE_STUDIES_ENDPOINTS.BY_ID(':id'), ({ params }) => {
    const { id } = params;
    const caseStudy = mockCaseStudies.find(c => c.id === id);
    if (!caseStudy) {
      return HttpResponse.json({
        status: false,
        status_code: 404,
        message: 'Case study not found',
        data: null,
        error: 'Not Found'
      }, { status: 404 });
    }
    return HttpResponse.json({
      status: true,
      status_code: 200,
      message: 'OK',
      data: caseStudy,
      error: null
    });
  }),
  
  http.post(CASE_STUDIES_ENDPOINTS.CREATE, async ({ request }) => {
    const payload = await request.json() as CreateCaseStudyRequest;
    const newCaseStudy: CaseStudy = {
      id: Math.random().toString(36).substring(7),
      ...payload,
      updatedAt: new Date().toISOString()
    };

    mockCaseStudies.push(newCaseStudy);
    return HttpResponse.json({
      status: true,
      status_code: 201,
      message: 'Created successfully',
      data: newCaseStudy,
      error: null
    }, { status: 201 });
  }),

  http.put(CASE_STUDIES_ENDPOINTS.UPDATE(':id'), async ({ request, params }) => {
    const { id } = params;
    const payload = await request.json() as CreateCaseStudyRequest;
    const index = mockCaseStudies.findIndex(c => c.id === id);
    if (index === -1) {
      return HttpResponse.json({
        status: false,
        status_code: 404,
        message: 'Case study not found',
        data: null,
        error: 'Not Found'
      }, { status: 404 });
    }
    const updated = {
      ...mockCaseStudies[index],
      ...payload,
      updatedAt: new Date().toISOString()
    };
    mockCaseStudies[index] = updated;
    return HttpResponse.json({
      status: true,
      status_code: 200,
      message: 'Updated successfully',
      data: updated,
      error: null
    });
  }),

  http.delete(CASE_STUDIES_ENDPOINTS.DELETE(':id'), ({ params }) => {
    const { id } = params;
    mockCaseStudies = mockCaseStudies.filter(c => c.id !== id);
    return HttpResponse.json({
      status: true,
      status_code: 204,
      message: 'Deleted successfully',
      data: null,
      error: null
    }, { status: 204 });
  })

]
